import React, { useCallback } from "react";
import {
  AHTodoCategoryIcon,
  Box,
  Circle,
  TodoCategoryIconType,
  TouchableBox,
} from "arkh";

export const IconBar = (props: {
  selectedIcon: TodoCategoryIconType;
  setSelectedIcon: (icon: TodoCategoryIconType) => void;
}) => {
  return (
    <Box style={{ flexDirection: "row" }}>
      {icons.map((icon) => (
        <Icon
          key={icon}
          icon={icon}
          selected={props.selectedIcon === icon}
          onPress={() => {
            props.setSelectedIcon(icon);
          }}
        />
      ))}
    </Box>
  );
};
const Icon = (props: {
  selected?: boolean;
  icon: TodoCategoryIconType;
  onPress: () => void;
}) => {
  const onPress = useCallback(() => {
    props.onPress();
  }, [props]);

  return (
    <TouchableBox onPress={onPress} spaceRight="medium">
      <Circle
        color={props.selected ? "primary" : "surface-backgroundControl"}
        size="large"
      >
        <AHTodoCategoryIcon
          color={props.selected ? "lightText" : "darkerText"}
          icon={props.icon}
        />
      </Circle>
    </TouchableBox>
  );
};
const icons = ["Check", "Message", "Order", "Sun"] as const;
